module.exports = __webpack_public_path__ + "img/car.2771b2cd.svg";